<template>
  <div class="listContent">
    <div class="up">
      <!-- <el-button @click="onImport">导入</el-button> -->
      <el-upload
        class="upload-demo"
        ref="fileRefs"
        :show-file-list="false"
        :on-change="handleChange"
        :before-upload="beforeUpload"
        action="https://test.rujiaowang.net/api/resource/get_oss_key"
        multiple
      >
        <i
          style="font-size: 70px; color: #409eff; margin: 20px"
          class="el-icon-circle-plus-outline"
        ></i>
        <div class="el-upload__text"><em>点击上传</em></div>
        <div style="padding-top: 10px">
          支持MP4、word等格式但文件大小不得超过20M
        </div>
      </el-upload>
      <div style="text-align: center">
        操作步骤：1.选择具体的课本章节; 2.选择要上传的文件
      </div>
    </div>
  </div>
</template>

<script>
import VueEvent from "@/api/eventBus.js";
import $ from "jquery";
import axios from "axios";
export default {
  data() {
    return {
      aliyunOssToken: "",
      fileList:[],
      fileact:{},
    };
  },
  watch: {},
  mounted() {
    this.get_oss_key();
  },
  methods: {
       handleChange(file, fileList) {
      // console.log(file, fileList);
      this.fileList = fileList;
      this.fileact = file.name;
    },
    get_oss_key() {
      var that = this;
      axios
        .post("https://test.rujiaowang.net/api/resource/get_oss_key")
        .then((res) => {
          that.aliyunOssToken = res.data.result.osssign;
        });
    },
    onImport() {
      if (JSON.parse(localStorage.getItem("cptid")).length < 12) {
        this.$message({
          message: "请先选择具体的课程",
        });
      } else {
        this.$refs["fileRefs"].$refs["upload-inner"].handleClick();
      }
    },
    beforeUpload(file) {
        // console.log(file.name)
      localStorage.setItem("name", JSON.stringify(file.name));
      var filename = file.name;
      var getSuffix = function (filename) {
        var pos = filename.lastIndexOf(".");
        var suffix = "";
        if (pos != -1) {
          suffix = filename.substring(pos);
        }
        return suffix;
      };
      filename =
        new Date().getTime() +
        Math.ceil(Math.random() * 10000) +
        getSuffix(filename);
      var _self = this;
      var formData = new FormData();
      //注意formData里append添加的键的大小写
      formData.append("key", _self.aliyunOssToken.dir + "eduyun/" + filename); //存储在oss的文件路径
      formData.append("OSSAccessKeyId", _self.aliyunOssToken.accessid); //accessKeyId
      formData.append("policy", _self.aliyunOssToken.policy); //policy
      formData.append("Signature", _self.aliyunOssToken.signature); //签名
      //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
      formData.append("callback", _self.aliyunOssToken.callback); //policy
      formData.append("file", file);
      formData.append("success_action_status", 200); //成功后返回的操作码
      var url = _self.aliyunOssToken.host;
      var fileUrl =
        _self.aliyunOssToken.host + "/" + _self.aliyunOssToken.dir + file.name;
      $.ajax({
        url: url,
        type: "POST",
        data: formData,
        // async: false,
        cache: false,
        contentType: false,
        processData: false,
        success: function (data) {
          // _self.addimg(data)//添加图片接口
          VueEvent.$emit("addimg", data);
          // console.log(data)
        },
        error: function (data) {},
      });
      if (file != null) {
        this.$emit("upload", false);
      }
    },
  },
};
</script>

<style scoped>
.right {
  float: right;
}
.left {
  float: left;
}
.clearfix:after {
  content: ".";
  display: block;
  clear: both;
  visibility: hidden;
  line-height: 0;
  height: 0;
  font-size: 0;
}
.clearfix {
  *zoom: 1;
}
.listContent {
  background-color: #fff;
  font-size: 16px;
  padding: 10px 0;
}
.listContent div {
  text-align: center;
  font-size: 12px;
  color: #606266;
  line-height: 20px;
}
.up {
  width: 360px;
  margin: 0 auto;
}
.up /deep/ .el-upload /deep/ .el-upload-dragger {
  border: none !important;
  height: 163px;
}
.up {
  position: relative;
}
.el-button {
  width: 360px;
  height: 160px;
  border: none !important;
  position: absolute;
  top: 0;
  left: 0;
  text-indent: -9999px;
  opacity: 0;
}
</style>
